import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom' 
import { useState } from 'react' 
import styled from 'styled-components'
import TimeAgo from 'components/utils/LocalizedTimeAgo';
import { useTranslation } from 'react-i18next'
import { MImage } from './zStyling.styled'
import { ConvItemContainer } from './zStyling.styled'

function ConversationItem({conversationId, image, fullName, date, lastMessage, isUnread, otherUserId}) {
    const { t } = useTranslation('messaging')
    const navigate = useNavigate()
    const [isSelected, setIsSelected] = useState()

    const handleView = () => {
        localStorage.setItem(`${conversationId}`, JSON.stringify({
            image: image,
            name: fullName,
            otherUserId: otherUserId ?? null
        }))
        navigate(`/messages/${conversationId}`)
    }

    useEffect(() => {  
        if(window.location.pathname.includes(conversationId)){
            setIsSelected(true)
        }else{
            setIsSelected(false)
        }
    }, [window.location.pathname, conversationId])


    let newDate = new Date(date)

    return (
        <ConvItemContainer
            isUnread={isUnread}
            isSelected={isSelected}
            onClick={handleView}
            >
            {
                isUnread && <section className='blueIcon'></section>
            } 
            <ConversationInfo> 
                <MImage src={image} alt={t('conversation.profileAlt')} />
                <NameAndLastMessage>
                    <span>{fullName}</span>
                    <p>{lastMessage ? lastMessage.slice(0, 35):'new message'}...</p>
                </NameAndLastMessage> 
            </ConversationInfo>
            <CItemRight><TimeAgo datetime={newDate}/></CItemRight>
        </ConvItemContainer>
    )
}

export default ConversationItem

const ConversationInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    color: #595959;
`

const NameAndLastMessage = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start; 
    color: var(--lightThemeFontColor);
    font-size: 15px;
    font-weight: 500;
    span{
        color: var(--lightThemeFontColor);
        text-align: left;
        font-size: 13px;
        font-weight: 500;
    }
    p{
        font-size: 11px;
        font-weight: 400;
        color: var(--lightThemeSecondaryFontColor);
        text-align: left;
    }
`

const CItemRight = styled.div`
    display: flex;
    height: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start; 
    color: #818181;
    font-size: 9px;
`
